const body = document.querySelector('body');

export const InitEditorPageTheme = () => {
  // On load, get the value of the page theme and set it to the body
  setThemeOnLoad();
  // Watch for theme color change (ACF Button Group Clicks)
  watchThemeChange();
}

const setThemeOnLoad = () => {
  // Watch for the sidebar to load with the values of the page theme
  let timerIntervals = 0;
  const timer = setInterval(() => {
    timerIntervals++;
    const selectedTheme = document.querySelector('.acf-postbox [data-name="transition_background_theme"] label.selected input');

    if(!!selectedTheme || timerIntervals > 100){
      clearInterval(timer);
      body.setAttribute('data-theme', selectedTheme.value);
    }
  }, 300);
}

const watchThemeChange = () => {
  document.addEventListener('click', (e) => {
    if(
    e.target.closest('[data-name="transition_background_theme"]') // ACF Field Button Group
    && e.target instanceof HTMLInputElement // Is Input element
    && e.target.closest('.acf-postbox') // Isn't a block field
    ){
      const theme = e.target.value;

      if(theme){
        body.setAttribute('data-theme', theme);
      }
    }
  });
}